module.exports = __webpack_public_path__ + "static/media/me.47096d42.png";